<template>
    <div class="field-selector">
        <div class="field-item" @click="selectField('text')">
            <i class="material-icons">text_fields</i>
            <span>{{ $t("tables.text") }}</span>
        </div>
        <div class="field-item" @click="selectField('long-text')">
            <i class="material-icons">subject</i>
            <span>{{ $t("tables.longText") }}</span>
        </div>
        <div class="field-item" @click="selectField('number')">
            <i class="material-icons">looks_one</i>
            <span>{{ $t("tables.number") }}</span>
        </div>
        <div class="field-item" @click="selectField('currency')">
            <i class="material-icons">attach_money</i>
            <span>{{ $t("tables.currency") }}</span>
        </div>
        <div class="field-item" @click="selectField('datetime')">
            <i class="material-icons">event</i>
            <span>{{ $t("tables.datetime") }}</span>
        </div>
        <div class="field-item" @click="selectField('dropdown')">
            <i class="material-icons">arrow_drop_down</i>
            <span>{{ $t("tables.dropdown") }}</span>
        </div>
        <div class="field-item" @click="selectField('checkbox')">
            <i class="material-icons">check_box</i>
            <span>{{ $t("tables.checkbox") }}</span>
        </div>
        <div class="field-item" @click="selectField('linked-record')">
            <i class="material-icons">switch_access_shortcut</i>
            <span>Linked Record</span>
        </div>

        <div class="divider"></div>
        <div class="field-item" @click="selectField('contact')">
            <i class="material-icons">person</i>
            <span>{{ $t("modules.contact") }}</span>
        </div>
        <div class="field-item not-implemented" @click="selectField('ticket')">
            <i class="material-icons">confirmation_number</i>
            <span>{{ $t("message.ticket") }}</span>
        </div>
        <div class="field-item" @click="selectField('task')">
            <i class="material-icons">assignment</i>
            <span>{{ $t("message.task") }}</span>
        </div>
        <div class="field-item not-implemented" @click="selectField('event')">
            <i class="material-icons">event</i>
            <span>{{ $t("message.event") }}</span>
        </div>
        <div class="field-item" @click="selectField('user')">
            <i class="material-icons">person</i>
            <span>{{ $t("message.user") }}</span>
        </div>
        <div class="divider"></div>

        <div class="field-item" @click="selectField('url')">
            <i class="material-icons">link</i>
            <span>URL</span>
        </div>
        <div class="field-item" @click="selectField('email')">
            <i class="material-icons">email</i>
            <span>{{ $t("tables.email") }}</span>
        </div>
        <div class="field-item" @click="selectField('phone')">
            <i class="material-icons">phone</i>
            <span>{{ $t("tables.phone") }}</span>
        </div>

        <div class="divider"></div>

        <div class="field-item" @click="selectField('json')">
            <i class="material-icons">code</i>
            <span>JSON</span>
        </div>
        <div class="field-item" @click="selectField('file')">
            <i class="material-icons">attachment</i>
            <span>{{ $t("tables.file") }}</span>
        </div>
        <div class="field-item" @click="selectField('image')">
            <i class="material-icons">image</i>
            <span>{{ $t("tables.image") }}</span>
        </div>
        <div class="field-item" @click="selectField('video')">
            <i class="material-icons">videocam</i>
            <span>{{ $t("tables.video") }}</span>
        </div>
        <div class="field-item" @click="selectField('audio')">
            <i class="material-icons">audiotrack</i>
            <span>{{ $t("tables.audio") }}</span>
        </div>
        <div class="field-item" @click="selectField('color')">
            <i class="material-icons">palette</i>
            <span>{{ $t("tables.color") }}</span>
        </div>
        <div class="field-item" @click="createAutomationButton">
            <i class="material-icons">smart_button</i>
            <span>{{ $t("tables.automationButton") }}</span>
        </div>
    </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    name: "FieldSelector",
    methods: {
        selectField(fieldType) {
            if (["ticket"].includes(fieldType)) {
                this.$message.error("This feature is not available yet.");
                return;
            }
            this.$emit("field-selected", fieldType);
        },
        createAutomationButton() {
            this.$emit("close");
            this.$feature.beforeCreateButtonAutomation(() => {
                this.selectField("automation-button");
            });
        },
    },
});
</script>

<style scoped lang="scss">
.field-selector {
    display: flex;
    flex-direction: column;

    .field-item {
        display: flex;
        align-items: center;
        padding: 8px;
        cursor: pointer;
        &.not-implemented {
            display: none;
        }

        &:hover {
            background-color: #f0f0f0;
        }

        i {
            margin-right: 8px;
        }
    }

    .divider {
        border-top: 1px solid #ccc;
        margin: 8px 0;
    }
}
</style>
